import type { Address } from "viem";

export function truncAddress(address: string | Address): string {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
}